import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ReadyState = 'CONNECTING' | 'OPEN' | 'CLOSING' | 'CLOSED';

interface WsStoreState {
  readyState: ReadyState;
  reconnectAttempt: number;
  lastHeartbeatLatency: number;
  lastConnectedAt: number | null;

  setReadyState: (state: ReadyState) => void;
  setReconnectAttempt: (attempt: number) => void;
  setHeartbeatLatency: (latency: number) => void;
  setLastConnectedAt: (timestamp: number) => void;
}

export const useWsStore = create<WsStoreState>()(
  devtools(
    (set) => ({
      readyState: 'CLOSED',
      reconnectAttempt: 0,
      lastHeartbeatLatency: -1,
      lastConnectedAt: null,

      setReadyState: (readyState: ReadyState) => {
        set({ readyState });
      },

      setReconnectAttempt: (reconnectAttempt: number) => {
        set({ reconnectAttempt });
      },

      setHeartbeatLatency: (lastHeartbeatLatency: number) => {
        set({ lastHeartbeatLatency });
      },

      setLastConnectedAt: (lastConnectedAt: number) => {
        set({ lastConnectedAt });
      },
    }),
    {
      name: 'ws-store'
    }
  )
);
